/*
 * Copyright (c) 2019 Eva Novotná, Juraj Šimon
 */

export default {
  namespaced: true,
  state: {
    about: false,
    whatIDo: false
  },
  getters: {
    about: state => {
      return state.about;
    },
    whatIDo: state => {
      return state.whatIDo;
    },
    activeSection: state => {
      let section = false;
      if (state.about) {
        section = "about";
      }
      if (state.whatIDo) {
        section = "whatido";
      }
      return section;
    }
  },
  mutations: {
    "enable-about": state => {
      state.about = true;
    },
    "disable-about": state => {
      state.about = false;
    },
    "enable-whatido": state => {
      state.whatIDo = true;
    },
    "disable-whatido": state => {
      state.whatIDo = false;
    }
  },
  actions: {
    setAbout({ commit }, active) {
      if (active) {
        commit("enable-about");
      } else {
        commit("disable-about");
      }
    },
    setWhatIDo({ commit }, active) {
      if (active) {
        commit("enable-whatido");
      } else {
        commit("disable-whatido");
      }
    }
  }
};
